import { usePaging } from 'hooks/usePaging';
import { useCallback } from 'react';
import { useGetUsersOptionsQuery } from 'services';
import { FindAllUserOptionDto, UseQueryOptionsType } from 'types';
import { DEFAULT_PAGE_SIZE } from 'utils';
const pageSize = DEFAULT_PAGE_SIZE;
export function useUsersOptions(
  params: Omit<FindAllUserOptionDto, 'pageIndex' | 'pageSize'>,
  options?: UseQueryOptionsType
) {
  const { organizationUnitId, statusId, userGroupId, keyword, isIgnoreUserOrganizationUnitId, isLoadAll } = params;
  const { pageIndex, resetPage, nextPage } = usePaging(params);
  const {
    data: dataResponse,
    isLoading,
    isFetching
  } = useGetUsersOptionsQuery(
    {
      keyword,
      organizationUnitId,
      statusId,
      userGroupId,
      isIgnoreUserOrganizationUnitId,
      pageIndex: pageIndex,
      pageSize,
      isLoadAll
    },
    {
      ...options
    }
  );

  const { rows, count } = dataResponse?.data || {};

  const hasMore = Boolean(rows && count && rows.length < count);
  const handleLoadMore = useCallback(() => {
    if (hasMore && !isFetching) {
      nextPage();
    }
  }, [hasMore, pageIndex]);

  return {
    usersOptions: rows || [],
    count: count || 0,
    isFetching,
    isLoading,
    handleLoadMore,
    hasMore,
    resetPage
  };
}
